var prefix = 'pm-alt-text';
export var ClassNames = {
    FLOATING_TOOLBAR_COMPONENT: prefix + "-alt-text-floating-toolbar",
};
//# sourceMappingURL=style.js.map